import React, { useState, useEffect } from "react";
import DynamicBreadcrumbs from "../../Uitiles/DynamicBreadcrumbs";
import PageSerch from "../Frontend/SerchDocters/Components/PageSerch";
import DoctorPage from "./Doctorpage";
import { useParams, useLocation } from "react-router-dom";
import { oneKlicks } from "../../SDK/oneclick";

const DoctorsDetailsView = () => {
    const { id } = useParams();
    const location = useLocation();

    // Determine if this is a hospital or doctor page
    const isHospital = location.pathname.includes('/hospital/');
    const [loadtype, setLoadtype] = useState(isHospital ? 'hospitals' : 'doctor');
    const [loading, setLoading] = useState(true);
    const [doctor, setDoctor] = useState(null);

    // Decrypt the id from the URL
    const decryptId = (encryptedId) => {
        const salt = 'meddylist';
        try {
            const decrypted = atob(encryptedId).replace(salt, '');
            return decrypted;
        } catch (e) {
            return '';
        }
    };
    const doctorId = decryptId(id);

    useEffect(() => {
        setLoadtype(isHospital ? 'hospitals' : 'doctor');
    }, [isHospital]);

    useEffect(() => {
        setLoading(true);
        const fetchDoctor = async () => {
            const tableSchema = 'users';
            const tableName = 'users';
            const conditions = { 
                user_type: loadtype === 'hospitals' ? 'hospitals' : 'doctor',
                id: doctorId 
            };
            const orderBy = '';
            const search = '';
            const pagination = '';
            const margedata = '';
            try {
                const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
                if (response && response.data && response.data.length > 0) {
                    setDoctor(response.data[0]);
                } else {
                    setDoctor(null);
                }
            } catch (err) {
                setDoctor(null);
            }
            setLoading(false);
        };
        if (doctorId) {
            fetchDoctor();
        } else {
            setDoctor(null);
            setLoading(false);
        }
    }, [doctorId, loadtype]);

    return (
        <div>
            <PageSerch />
            <DynamicBreadcrumbs />
            {loading ? (
                <div>Loading...</div>
            ) : doctor ? (
                <DoctorPage data={doctor} loadtype={loadtype} />
            ) : (
                <div>No doctor found</div>
            )}
        </div>
    );
};

export default DoctorsDetailsView;
